import { TodoItem } from "@/components/Types";

const NOTIFICATIONS_SHOWN_CREATED_LOCAL_STORAGE_KEY = 'todo-ln';

function replaceTodoItemUrlTokens(url: string, item: Partial<TodoItem>) {
    url = url.replaceAll(':itemId', item._id?.toString() ?? '');
    url = url.replaceAll(':characterId', item.chatConfig?.characterId ?? '');

    return url;
}

function getLocalNotificationCreated(todoItemId: string) {
    const cacheJson = localStorage.getItem(NOTIFICATIONS_SHOWN_CREATED_LOCAL_STORAGE_KEY);
    const cache = cacheJson ? JSON.parse(cacheJson) : {};
    return cache[todoItemId] ?? false;
}

function setLocalNotificationCreated(todoItemId: string, shown: boolean) {
    const cacheJson = localStorage.getItem(NOTIFICATIONS_SHOWN_CREATED_LOCAL_STORAGE_KEY);
    const cache = cacheJson ? JSON.parse(cacheJson) : {};
    cache[todoItemId] = shown ? Date.now() : null;
    localStorage.setItem(NOTIFICATIONS_SHOWN_CREATED_LOCAL_STORAGE_KEY, JSON.stringify(cache));
}

function purgeLocalNotificationsCreatedCache() {
    const cacheJson = localStorage.getItem(NOTIFICATIONS_SHOWN_CREATED_LOCAL_STORAGE_KEY);
    const cache = cacheJson ? JSON.parse(cacheJson) : {};

    const now = Date.now();

    for (const todoItemId in cache) {
        if (cache[todoItemId] != null && cache[todoItemId] < now - 1000 * 60 * 60 * 24 * 3) { // 3 days
            delete cache[todoItemId];
        }
    }

    localStorage.setItem(NOTIFICATIONS_SHOWN_CREATED_LOCAL_STORAGE_KEY, JSON.stringify(cache));
}

export const todoListToolsUi = {
    replaceTodoItemUrlTokens,
    getLocalNotificationCreated,
    setLocalNotificationCreated,
    purgeLocalNotificationsCreatedCache,
}